import React from "react";
import {Col, FormGroup, Input, Label, Row} from "reactstrap";

import {LangController} from "../../../components/tabs/langController";
import MarkdownInput from "../../../components/inputs/MarkdownInput";


const AfiLangs = props => {
    const setDataDefault = (activeLangs, setLangChilds) => {
        const items = activeLangs.map( lang => ({
            id: '',
            lang: { id: lang?.id, name: lang?.name, showOrder: lang?.showOrder },
            slogan: '',
            schedule: '',
            image: '',
            longDescription: '',
            shortDescription: '',
            onBoardServices: '',
            recommendation: '',
            included: '',
            address: '',
        }) )

        setLangChilds(items);
    }

    const getFormulary = (child, index, disableInputs, onInputChange) => <Row>
        <Col md="12">
            <FormGroup>
                <MarkdownInput
                    label={'Slogan'}
                    placeholder={'Slogan'}
                    type="textarea"
                    name="slogan"
                    rows={'3'}
                    onChange={onInputChange}
                    disabled={disableInputs}
                    child={child}
                />
            </FormGroup>
        </Col>
        <Col md="8">
            <FormGroup>
                <MarkdownInput
                    label={'Horarios de apertura'}
                    placeholder={'Ingrese horarios'}
                    type="text"
                    name="schedule"
                    onChange={onInputChange}
                    disabled={disableInputs}
                    child={child}
                />
            </FormGroup>
        </Col>
        <Col md="4">
            <FormGroup>
                <Label>Imagen</Label>
                <Input type="text" name="image"
                       placeholder="Ingrese nombre de imagen"
                       value={child.image}
                       onChange={ ({target:{name, value}}) => onInputChange(name,value,child?.lang) }
                       disabled={disableInputs}
                />
            </FormGroup>
        </Col>
        <Col md="12">
            <FormGroup>
                <MarkdownInput
                    label={'Descripción Corta'}
                    placeholder={'Ingrese descripción corta'}
                    type="textarea"
                    name="shortDescription"
                    rows={'2'}
                    onChange={onInputChange}
                    disabled={disableInputs}
                    child={child}
                />
            </FormGroup>
        </Col>
        <Col md="12">
            <FormGroup>
                <MarkdownInput
                    label={'Descripción larga'}
                    placeholder={'Ingrese descripción larga'}
                    type="textarea"
                    name="longDescription"
                    rows={'6'}
                    onChange={onInputChange}
                    disabled={disableInputs}
                    child={child}
                />
            </FormGroup>
        </Col>
        <Col md="12">
            <FormGroup>
                <MarkdownInput
                    label={'Servicios'}
                    placeholder={'Ingrese los servicios'}
                    type="textarea"
                    name="onBoardServices"
                    rows={'3'}
                    onChange={onInputChange}
                    disabled={disableInputs}
                    child={child}
                />
            </FormGroup>
        </Col>
        <Col md="6">
            <FormGroup>
                <MarkdownInput
                    label={'Recomendaciones'}
                    placeholder={'Recomendaciones . . .'}
                    type="textarea"
                    name="recommendation"
                    rows={'10'}
                    onChange={onInputChange}
                    disabled={disableInputs}
                    child={child}
                />
            </FormGroup>
        </Col>
        <Col md="6">
            <FormGroup>
                <MarkdownInput
                    label={'Incluye'}
                    placeholder={'Incluye . . '}
                    type="textarea"
                    name="included"
                    rows={'10'}
                    onChange={onInputChange}
                    disabled={disableInputs}
                    child={child}
                />
            </FormGroup>
        </Col>
        <Col md="12">
            <FormGroup>
                <MarkdownInput
                    label={'Dirección'}
                    placeholder={'Ingrese dirección'}
                    type="text"
                    name="address"
                    onChange={onInputChange}
                    disabled={disableInputs}
                    child={child}
                />
            </FormGroup>
        </Col>
    </Row>

    return <LangController
        markdown={true}
        langs={props.langs}
        setLangs={props.setLangs}
        getFormulary={getFormulary}
        setDataDefault={setDataDefault}
        translatableLangs={props.translatableLangs}
    />
}

export default AfiLangs